import {default as German} from './lngs/de';
import {default as English} from './lngs/en';
import {default as Spanish} from './lngs/es';
import {default as French} from './lngs/fr';
import {default as Portuguese} from './lngs/pt';
import {default as Serbian} from './lngs/sr';

export default {
    'de': German,
    'en': English,
    'es': Spanish,
    'fr': French,
    'pt': Portuguese,
    'sr': Serbian
}

export {German as de, English as en, Spanish as es, French as fr, Portuguese as pt, Serbian as sr}
export const AvailableLanguages = ['de', 'en', 'es', 'fr', 'pt', 'sr'];
